/* GTM: add_to_cart — fires on every successful AJAX cart add (Impulse ajaxProduct:added event) */
(function () {
  document.addEventListener('ajaxProduct:added', function (evt) {
    var item = evt.detail && evt.detail.product;
    if (!item) return;
    var price = parseFloat((item.price / 100).toFixed(2));
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: currency,
        value: price * (item.quantity || 1),
        items: [{
          item_id: item.sku,
          item_name: item.product_title,
          quantity: item.quantity || 1,
          price: price
        }]
      }
    });
  });
})();


/**
 * Boost SD Filter - Reverse Toggle State
 * Auto-open filter on mobile on every collection page
 * Respects user preference if they manually closed the filter
 */
(function() {
    'use strict';
    
    var SELECTORS = {
        filterTree: '.boost-sd__filter-tree-vertical',
        toggleButton: '.boost-sd__filter-tree-toggle-button',
        labelHide: '.boost-sd__filter-tree-toggle-button-title--hide-filter'
    };
    
    var STORAGE_KEY = 'boostFilterUserClosed';
    
    var lastUrl = location.href;
    var isProcessing = false;
    var toggleListenerAttached = false;
    
    function isMobileView() {
        return window.innerWidth <= 991;
    }
    
    function isFilterOpen() {
        var labelHide = document.querySelector(SELECTORS.labelHide);
        if (labelHide) {
            return getComputedStyle(labelHide).display !== 'none';
        }
        return false;
    }
    
    // === localStorage Funktionen ===
    function getUserPrefersClosed() {
        try {
            return localStorage.getItem(STORAGE_KEY) === 'true';
        } catch (e) {
            return false;
        }
    }
    
    function setUserPrefersClosed(closed) {
        try {
            if (closed) {
                localStorage.setItem(STORAGE_KEY, 'true');
            } else {
                localStorage.removeItem(STORAGE_KEY);
            }
            console.log('Boost SD Filter: User preference saved - closed:', closed);
        } catch (e) {
            console.log('Boost SD Filter: Could not save preference');
        }
    }
    
    // === Toggle Button Click Handler ===
    function attachToggleListener() {
        if (toggleListenerAttached) return;
        
        var toggleButton = document.querySelector(SELECTORS.toggleButton);
        if (!toggleButton) return;
        
        toggleButton.addEventListener('click', function() {
            // Ignoriere programmatische Klicks
            if (isProcessing) return;
            
            // Nach dem Klick kurz warten, dann neuen Zustand prüfen
            setTimeout(function() {
                var nowOpen = isFilterOpen();
                // User hat geschlossen = Filter ist jetzt ZU
                setUserPrefersClosed(!nowOpen);
            }, 100);
        });
        
        toggleListenerAttached = true;
        console.log('Boost SD Filter: Toggle listener attached');
    }
    
    function openFilterIfClosed() {
        if (isProcessing || !isMobileView()) return;
        
        // Prüfe ob User den Filter manuell geschlossen hatte
        if (getUserPrefersClosed()) {
            console.log('Boost SD Filter: User prefers closed - skipping auto-open');
            return;
        }
        
        var toggleButton = document.querySelector(SELECTORS.toggleButton);
        var filterTree = document.querySelector(SELECTORS.filterTree);
        
        if (!toggleButton || !filterTree) return;
        
        if (!isFilterOpen()) {
            isProcessing = true;
            console.log('Boost SD Filter: Opening...');
            toggleButton.click();
            
            // Reset nach kurzer Verzögerung
            setTimeout(function() {
                isProcessing = false;
            }, 500);
        }
    }
    
    function waitForFilterAndOpen() {
        var attempts = 0;
        var maxAttempts = 50;
        
        var checkInterval = setInterval(function() {
            attempts++;
            
            var toggleButton = document.querySelector(SELECTORS.toggleButton);
            
            if (toggleButton) {
                clearInterval(checkInterval);
                // Toggle Listener anbringen
                attachToggleListener();
                // Kleine Verzögerung damit Boost fertig rendern kann
                setTimeout(openFilterIfClosed, 200);
            }
            
            if (attempts >= maxAttempts) {
                clearInterval(checkInterval);
            }
        }, 100);
    }
    
    // === URL Change Detection (für AJAX Navigation) ===
    function onUrlChange() {
        if (location.href !== lastUrl) {
            lastUrl = location.href;
            console.log('Boost SD Filter: URL changed, re-checking...');
            waitForFilterAndOpen();
        }
    }
    
    // Popstate (Browser back/forward)
    window.addEventListener('popstate', function() {
        setTimeout(function() {
            onUrlChange();
        }, 300);
    });
    
    // URL Polling (für pushState ohne popstate)
    setInterval(onUrlChange, 500);
    
    // === MutationObserver für dynamisch geladene Filter ===
    function startObserver() {
        var observer = new MutationObserver(function(mutations) {
            // Prüfe ob neuer Filter hinzugefügt wurde
            var filterAdded = mutations.some(function(mutation) {
                return Array.from(mutation.addedNodes).some(function(node) {
                    if (node.nodeType !== 1) return false;
                    return node.matches && node.matches(SELECTORS.filterTree) ||
                           node.querySelector && node.querySelector(SELECTORS.filterTree);
                });
            });
            
            if (filterAdded) {
                console.log('Boost SD Filter: New filter detected');
                // Reset listener flag, da neuer Filter = neuer Button
                toggleListenerAttached = false;
                attachToggleListener();
                setTimeout(openFilterIfClosed, 300);
            }
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    
    // === INIT ===
    function init() {
        console.log('Boost SD Filter: Initializing...');
        waitForFilterAndOpen();
        startObserver();
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
})();
////////////////////
// Boost SD Product Enhancements
// 1. Splits "Product - Color" into separate elements
// 2. Adds 5 stars after the price
////////////////////
(function() {
    'use strict';

    function processProductItems() {
        const productItems = document.querySelectorAll('.boost-sd__product-item');

        productItems.forEach(productItem => {
            // === TITLE/COLOR SPLITTER ===
            const productTitleElement = productItem.querySelector('.boost-sd__product-title');

            if (productTitleElement && !productItem.dataset.colorProcessed) {
                const productText = productTitleElement.textContent.trim();
                const splitPattern = / - /;
                const parts = productText.split(splitPattern);

                if (parts.length >= 2) {
                    const title = parts[0].trim();
                    const color = parts.slice(1).join(' - ').trim();

                    // Update title
                    productTitleElement.textContent = title;

                    // Create color element
                    const colorDiv = document.createElement('div');
                    colorDiv.className = 'boost-sd__product-color';
                    colorDiv.textContent = color;

                    // Insert after title link wrapper
                    const titleLink = productTitleElement.closest('a.boost-sd__product-link');
                    if (titleLink && titleLink.parentNode) {
                        titleLink.parentNode.insertBefore(colorDiv, titleLink.nextSibling);
                    } else {
                        productTitleElement.parentNode.insertBefore(colorDiv, productTitleElement.nextSibling);
                    }

                    productItem.dataset.colorProcessed = 'true';
                }
            }

            // === STARS ===
            if (!productItem.dataset.starsAdded) {
                const priceElement = productItem.querySelector('.boost-sd__product-price');
                
                if (priceElement) {
                    const starsDiv = document.createElement('div');
                    starsDiv.className = 'boost-sd__product-stars';
                    
                    for (let i = 0; i < 5; i++) {
                        const star = document.createElement('span');
                        star.className = 'star';
                        star.textContent = '★';
                        starsDiv.appendChild(star);
                    }

                    priceElement.parentNode.insertBefore(starsDiv, priceElement.nextSibling);
                    productItem.dataset.starsAdded = 'true';
                }
            }
        });
    }

    // Debounce
    let debounceTimer;
    function debouncedProcess() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(processProductItems, 50);
    }

    // Observer for Boost async loading
    const observer = new MutationObserver(function(mutations) {
        for (const mutation of mutations) {
            if (mutation.addedNodes.length) {
                for (const node of mutation.addedNodes) {
                    if (node.nodeType === 1 && (
                        node.classList?.contains('boost-sd__product-item') ||
                        node.querySelector?.('.boost-sd__product-item')
                    )) {
                        debouncedProcess();
                        return;
                    }
                }
            }
        }
    });

    if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
        processProductItems();
    } else {
        document.addEventListener('DOMContentLoaded', function() {
            observer.observe(document.body, { childList: true, subtree: true });
            processProductItems();
        });
    }
})();

////////////////////
// Cart Discount Code (cart page + theme drawer)
// AJAX validation via /discount/ + /cart.js, prefill on load, SVG loading spinner
////////////////////
(function() {
    'use strict';

    var SPINNER_SVG = '<svg class="cart-discount-box__spinner" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-dasharray="47" stroke-dashoffset="15" opacity="0.8"/></svg>';
    var strings = window.cartStrings || {};

    function setMessage(box, text, type) {
        var msg = box.querySelector('.cart-discount-box__msg');
        if (!msg) {
            msg = document.createElement('div');
            msg.className = 'cart-discount-box__msg';
            var row = box.querySelector('.cart-discount-box__row');
            if (row) row.after(msg);
        }
        msg.textContent = text;
        msg.className = 'cart-discount-box__msg' + (type ? ' cart-discount-box__msg--' + type : '');
    }

    function setLoading(box, loading) {
        var input = box.querySelector('input');
        var btn = box.querySelector('button');
        input.disabled = loading;
        btn.disabled = loading;
        if (loading) {
            btn.innerHTML = SPINNER_SVG;
        } else {
            btn.textContent = strings.discountApply || 'Apply';
        }
    }

    function applyDiscount(input) {
        var code = input.value.trim();
        if (!code) return;

        var box = input.closest('.cart-discount-box');
        setLoading(box, true);
        setMessage(box, '', '');

        fetch('/discount/' + encodeURIComponent(code))
            .then(function() { return fetch('/cart.js'); })
            .then(function(r) { return r.json(); })
            .then(function(cart) {
                var match = (cart.discount_codes || []).find(function(d) {
                    return d.code.toLowerCase() === code.toLowerCase();
                });
                if (match && match.applicable) {
                    setMessage(box, strings.discountSuccess || 'Discount applied! Redirecting\u2026', 'success');
                    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
                } else {
                    setMessage(box, strings.discountErrorInvalid || 'Invalid discount code. Please try again.', 'error');
                    setLoading(box, false);
                }
            })
            .catch(function() {
                setMessage(box, strings.discountErrorGeneric || 'Something went wrong. Please try again.', 'error');
                setLoading(box, false);
            });
    }

    /* Pre-fill all discount inputs if a code is already applied */
    function prefillDiscount() {
        fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
                var applied = (cart.discount_codes || []).find(function(d) { return d.applicable; });
                if (!applied) return;
                document.querySelectorAll('.cart-discount-box__input').forEach(function(input) {
                    if (!input.value) {
                        input.value = applied.code;
                        var box = input.closest('.cart-discount-box');
                        var prefillMsg = (strings.discountPrefillApplied || 'Discount "{{ code }}" applied.').replace('{{ code }}', applied.code);
                        setMessage(box, prefillMsg, 'success');
                    }
                });
            });
    }


    /* Event delegation — works for cart page and theme drawer */
    document.addEventListener('click', function(e) {
        var btn = e.target.closest('.cart-discount-box__btn');
        if (!btn) return;
        var box = btn.closest('.cart-discount-box');
        if (box) applyDiscount(box.querySelector('input'));
    });

    document.addEventListener('keydown', function(e) {
        if (e.key !== 'Enter') return;
        var input = e.target.closest('.cart-discount-box__input');
        if (input) {
            e.preventDefault();
            applyDiscount(input);
        }
    });

    function init() {
        prefillDiscount();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

////////////////////
// Mobile Fixed Add to Cart
// Forwards clicks from the fixed mobile bar to the product form
////////////////////
(function() {
    'use strict';

    document.addEventListener('click', function(evt) {
        var btn = evt.target.closest && evt.target.closest('[id^="MobileAddToCart-"]');
        if (!btn || btn.disabled) return;

        var formId = btn.getAttribute('data-form-id') || btn.getAttribute('aria-controls');
        if (!formId) return;

        var form = document.getElementById(formId);
        if (!form) return;

        // Trigger the form submit - AjaxProduct's submit handler will intercept it
        if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
        } else {
            // Fallback for older browsers: click the inline submit button
            var submit = form.querySelector('.add-to-cart');
            if (submit) submit.click();
        }
    });

    // Mirror inline button state (text, disabled, loading) to mobile button
    function initMobileButtons() {
        document.querySelectorAll('.mobile-add-to-cart').forEach(function(el) {
            var sid = el.getAttribute('data-section-id');
            if (!sid) return;

            var inlineBtn = document.getElementById('AddToCart-' + sid);
            var inlineText = document.getElementById('AddToCartText-' + sid);
            var mobileBtn = document.getElementById('MobileAddToCart-' + sid);
            var mobileText = document.getElementById('MobileAddToCartText-' + sid);

            if (!inlineBtn || !mobileBtn) return;

            // Initial sync
            if (inlineText && mobileText) mobileText.innerHTML = inlineText.innerHTML;
            mobileBtn.disabled = inlineBtn.disabled;

            // Observe and mirror changes
            var observer = new MutationObserver(function() {
                if (inlineText && mobileText) mobileText.innerHTML = inlineText.innerHTML;
                mobileBtn.disabled = inlineBtn.disabled;
                mobileBtn.classList.toggle('btn--loading', inlineBtn.classList.contains('btn--loading'));
            });
            observer.observe(inlineBtn, { attributes: true, attributeFilter: ['disabled', 'class'], childList: true, subtree: true });
            if (inlineText && inlineText !== inlineBtn) {
                observer.observe(inlineText, { childList: true, characterData: true, subtree: true });
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMobileButtons);
    } else {
        initMobileButtons();
    }
})();

////////////////////
// Wishlist-to-Cart Bridge
// AJAX add-to-cart, price cleanup, CTA icon swap
////////////////////
(function() {
    'use strict';

    /* ---- AJAX add-to-cart (no page redirect) ---- */
    function ajaxAddToCart(form) {
        var btn = form.querySelector('.wk-cta-button');
        if (btn) btn.classList.add('wk-cta--loading');

        var variantId = form.querySelector('input[name="id"]');
        if (!variantId || !variantId.value) {
            if (btn) btn.classList.remove('wk-cta--loading');
            return;
        }

        fetch('/cart/add.js', {
            method: 'POST',
            body: 'id=' + variantId.value + '&quantity=1',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(function(r) { return r.json(); })
        .then(function(product) {
            if (btn) btn.classList.remove('wk-cta--loading');
            if (product.status === 422) return;

            /* Remove item from wishlist (move-to-cart behaviour) */
            var card = form.closest('.wk-product-card');
            var removeBtn = card && card.querySelector('remove-button');
            var itemId = removeBtn && removeBtn.getAttribute('data-wishlist-item-id');
            var removePromise = (itemId && window.WishlistKing)
                ? window.WishlistKing.removeWishlistItem({ wishlistItemId: itemId })
                : Promise.resolve();

            if (form.closest('#CartDrawer')) {
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    detail: { product: product }
                }));
            } else {
                (removePromise || Promise.resolve()).then(function() {
                    window.location.reload();
                });
            }
        })
        .catch(function() {
            if (btn) btn.classList.remove('wk-cta--loading');
        });
    }

    /* Intercept click on CTA button — capture phase, block WK handlers */
    document.addEventListener('click', function(e) {
        var btn = e.target.closest('.cart-wishlist-section .wk-cta-button');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var form = btn.closest('.wk-form');
        if (form) ajaxAddToCart(form);
    }, true);

    /* Intercept form submit as backup — capture phase, block WK handlers */
    document.addEventListener('submit', function(e) {
        var form = e.target.closest ? e.target.closest('.cart-wishlist-section .wk-form') : null;
        if (!form) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        ajaxAddToCart(form);
    }, true);

    /* ---- Strip currency code (GBP/EUR/etc) from prices ---- */
    function cleanPrices() {
        document.querySelectorAll('.cart-wishlist-section .wk-current-price').forEach(function(el) {
            el.childNodes.forEach(function(node) {
                if (node.nodeType === 3 && /\s*(GBP|EUR|USD|AUD)\b/.test(node.textContent)) {
                    node.textContent = node.textContent.replace(/\s*(GBP|EUR|USD|AUD)\b/g, '');
                }
            });
        });
    }

    /* ---- Replace "Add to Cart" label with cart icon ---- */
    var cartSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>';

    function updateButtons() {
        document.querySelectorAll('.cart-wishlist-section .wk-cta-button').forEach(function(btn) {
            var label = btn.querySelector('.wk-cta-label');
            if (!label) return;
            /* Use btn.disabled instead of text — works in all locales */
            if (!btn.disabled && !btn.classList.contains('wk-cta--icon')) {
                btn.classList.add('wk-cta--icon');
                label.innerHTML = cartSVG;
            }
        });
    }

    /* ---- Disable CTA button when no size selected or sold out ---- */
    function syncCtaVisibility() {
        document.querySelectorAll('.cart-wishlist-section .wk-cta-button').forEach(function(btn) {
            var label = btn.querySelector('.wk-cta-label');
            if (!label) return;
            /* Use btn.disabled instead of text — works in all locales */
            if (btn.disabled && !btn.classList.contains('wk-cta--nosize')) {
                /* No size selected or sold out — show as disabled icon button */
                btn.style.display = '';
                btn.classList.add('wk-cta--icon', 'wk-cta--nosize');
                label.innerHTML = cartSVG;
            } else if (!btn.disabled && btn.classList.contains('wk-cta--nosize')) {
                /* Size was picked and available — re-enable */
                btn.classList.remove('wk-cta--nosize');
            }
        });
    }

    /* Listen for WK dropdown changes (they use custom elements, fire change on .wk-input) */
    document.addEventListener('change', function(e) {
        if (e.target.closest('.cart-wishlist-section wk-option-select')) {
            /* Small delay for WK to update the CTA button text */
            setTimeout(function() { syncCtaVisibility(); updateButtons(); }, 100);
        }
    });

    /* ---- Rename raw Akeneo option names to localized Size label ---- */
    /* Mirrors Liquid is_size logic — auto-handles any locale Akeneo pushes, no list to maintain */
    var sizeLabel = (theme.strings && theme.strings.sizeLabel) || 'Size';
    function isSizeOptionName(str) {
        var s = (str || '').toLowerCase();
        return s.indexOf('size') !== -1 || s.indexOf('maat') !== -1 ||
               s.indexOf('taille') !== -1 || s.indexOf('groesse') !== -1 ||
               s.indexOf('grosse') !== -1;
    }

    var MODEL_LABEL_MAP = {
        'chill': 'Chill',
        'cloudnine': 'Cloudnine',
        'coastal': 'Coastal',
        'connie': 'Connie',
        'laze': 'Laze',
        'levitate': 'Levitate',
        'offshore': 'Offshore',
        'pointbreak': 'Pointbreak',
        'skyhigh': 'Skyhigh',
        'solace': 'Solace',
        'soleseeker': 'Soleseeker',
        'sundreamer': 'Sundreamer',
        'sundrifter': 'Sundrifter'
    };

    var COLOR_LABEL_MAP = {
        'aqua': 'Aqua',
        'beige': 'Beige',
        'black': 'Black',
        'blush': 'Blush',
        'blozen': 'Blush',
        'chocolate': 'Chocolate',
        'chocolade': 'Chocolate',
        'graphite': 'Graphite',
        'grafiet': 'Graphite',
        'hot-pink': 'Hot Pink',
        'felroze': 'Hot Pink',
        'khaki': 'Khaki',
        'kaki': 'Khaki',
        'lavender': 'Lavender',
        'lavendel': 'Lavender',
        'midnight-blue': 'Midnight Blue',
        'natural': 'Natural',
        'natuurlijk': 'Natural',
        'peach-pink': 'Peach Pink',
        'rose': 'Rose',
        'sand': 'Sand',
        'zand': 'Sand',
        'seagrass': 'Seagrass',
        'zeegras': 'Seagrass',
        'silver': 'Silver',
        'white': 'White',
        'wit': 'White',
        'zwart': 'Black'
    };

    function normalizeDisplayKey(value) {
        return String(value || '')
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/&/g, 'and')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    function titleCaseSlug(slug) {
        return String(slug || '').split('-').filter(Boolean).map(function(part) {
            return part.charAt(0).toUpperCase() + part.slice(1);
        }).join(' ');
    }

    function productLabelsFromHandle(handle) {
        handle = normalizeDisplayKey(handle);
        if (!handle) return null;
        var parts = handle.split('-');
        var modelSlug = parts.shift();
        var colorSlug = parts.join('-');
        var model = MODEL_LABEL_MAP[modelSlug] || titleCaseSlug(modelSlug);
        var color = COLOR_LABEL_MAP[colorSlug] || titleCaseSlug(colorSlug);
        return { model: model, color: color, title: color ? model + ' - ' + color : model };
    }

    function productHandleFromUrl(url) {
        var match = String(url || '').match(/\/products\/([^?#/]+)/);
        return match ? match[1] : '';
    }

    function renderSplitProductTitle(el, labels) {
        el.textContent = '';

        var model = document.createElement('span');
        model.className = 'wk-product-title-model';
        model.textContent = labels.model;

        var separator = document.createElement('span');
        separator.className = 'wk-product-title-separator';
        separator.setAttribute('aria-hidden', 'true');
        separator.textContent = ' - ';

        var color = document.createElement('span');
        color.className = 'wk-product-title-color';
        color.textContent = labels.color;

        el.appendChild(model);
        el.appendChild(separator);
        el.appendChild(color);
    }

    function replaceSizeSlug(text) {
        return text.replace(/[a-z]+(?:_[a-z]+)+/gi, function(m) {
            return isSizeOptionName(m) ? sizeLabel : m;
        });
    }

    function renameOptionLabels() {
        /* WK label shows option name directly — replace whole text */
        document.querySelectorAll('label.wk-label').forEach(function(el) {
            el.childNodes.forEach(function(node) {
                if (node.nodeType !== 3) return;
                var t = node.textContent.trim();
                if (isSizeOptionName(t) && t !== sizeLabel) node.textContent = sizeLabel;
            });
        });
        /* Dropdown placeholder: "Select shoe_size_eu" → "Select Size" */
        document.querySelectorAll('select.wk-input').forEach(function(sel) {
            var first = sel.options[0];
            if (first && isSizeOptionName(first.textContent)) {
                var replaced = replaceSizeSlug(first.textContent);
                if (replaced !== first.textContent) first.textContent = replaced;
            }
        });
        /* Inline display text and CTA label */
        document.querySelectorAll('.wk-option-select .wk-text, span.wk-cta-label').forEach(function(el) {
            el.childNodes.forEach(function(node) {
                if (node.nodeType !== 3 || !isSizeOptionName(node.textContent)) return;
                var replaced = replaceSizeSlug(node.textContent);
                if (replaced !== node.textContent) node.textContent = replaced;
            });
        });
    }

    function normalizeWishlistProductTitles() {
        document.querySelectorAll('.cart-wishlist-section .wk-product-card').forEach(function(card) {
            var productLink = card.querySelector('a[href*="/products/"]');
            var labels = productLabelsFromHandle(productHandleFromUrl(productLink && productLink.getAttribute('href')));
            if (!labels) return;

            var titleEl = card.querySelector('.wk-product-title .wk-text-link, .wk-product-title');
            if (titleEl && titleEl.textContent.replace(/\s+/g, ' ').trim() !== labels.title) {
                renderSplitProductTitle(titleEl, labels);
            }

            card.querySelectorAll('a[href*="/products/"], img[alt]').forEach(function(el) {
                if (el.hasAttribute('aria-label')) el.setAttribute('aria-label', labels.title);
                if (el.hasAttribute('alt')) el.setAttribute('alt', labels.title);
            });
        });
    }

    /* ---- Observe WK sections for async renders ---- */
    function refresh() { cleanPrices(); updateButtons(); syncCtaVisibility(); renameOptionLabels(); normalizeWishlistProductTitles(); }

    var observer = new MutationObserver(refresh);
    document.querySelectorAll('.cart-wishlist-section').forEach(function(el) {
        observer.observe(el, { childList: true, subtree: true, characterData: true });
    });

    /* Observe WK components on standalone wishlist page (/apps/wishlist) */
    document.querySelectorAll('wishlist-page').forEach(function(el) {
        if (!el.closest('.cart-wishlist-section')) {
            observer.observe(el, { childList: true, subtree: true, characterData: true });
        }
    });

    setTimeout(refresh, 500);
    setTimeout(refresh, 1500);
    setTimeout(refresh, 3000);
})();



/* Wishlist GTM Bridge */
(function () {
  function getHandle(btn) {
    var h = btn.getAttribute('data-product-handle');
    if (h) return h;
    var wkEl = btn.closest('wishlist-button-collection');
    return wkEl ? wkEl.getAttribute('data-product-handle') : null;
  }

  function publish(handle, variantId) {
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variant = variantId
          ? product.variants.find(function (v) { return String(v.id) === String(variantId); })
          : null;
        variant = variant || product.variants[0];
        var price = parseFloat((variant.price / 100).toFixed(2));
        var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'add_to_wishlist',
          ecommerce: {
            currency: currency,
            value: price,
            items: [{
              item_id: variant.sku,
              item_name: product.title,
              price: price
            }]
          }
        });
      })
      .catch(function () { /* silent */ });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-btn');
    if (!btn) btn = e.target.closest('wishlist-button-collection button');
    if (!btn) return;
    if (btn.closest('.cart-wishlist-section')) return;
    if (btn.classList.contains('wk-selected')) return;

    var handle = getHandle(btn);
    if (!handle) return;
    var variantId = btn.getAttribute('data-variant-id');

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (btn.classList.contains('wk-selected')) {
          observer.disconnect();
          publish(handle, variantId);
          break;
        }
      }
    });
    observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
    setTimeout(function () { observer.disconnect(); }, 3000);
  }, true); // capture phase — fires before WK stops propagation
})();


/* PDP Wishlist State Sync */
/* The .wishlist-btn has wk-headless attr, so WK manages its state — but WK's headless
   init fetches the wishlist async and resets the button to "not selected" since _state is empty.
   We fetch the WK API, apply wk-selected, then guard against WK's init removing it.
   Guard stops on first user click (so normal add/remove interactions work correctly). */
(function () {
  var btn = document.querySelector('.wishlist-btn');
  if (!btn) return; // Only runs on PDP

  function applyAndGuard() {
    btn.classList.add('wk-selected');

    var userClicked = false;
    btn.addEventListener('click', function () { userClicked = true; }, { capture: true, once: true });

    var guard = new MutationObserver(function () {
      if (userClicked) {
        guard.disconnect();
        return;
      }
      if (!btn.classList.contains('wk-selected')) {
        btn.classList.add('wk-selected'); // WK init removed it — put it back
      }
    });
    guard.observe(btn, { attributes: true, attributeFilter: ['class'] });
    setTimeout(function () { guard.disconnect(); }, 3000); // stop after WK init window
  }

  function syncState() {
    var wk = window.WishlistKing;
    if (!wk || !wk._apis || !wk._apis.wishlist) return;

    var productId = window.meta && window.meta.product && window.meta.product.id;
    if (!productId) return;

    var api = wk._apis.wishlist;
    fetch(api.host + '/wishlists/mine', { headers: api.headers })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var items = (data.wishlist && data.wishlist.items) || [];
        var inWishlist = items.some(function (item) {
          return String(item.productId) === String(productId);
        });
        if (inWishlist) applyAndGuard();
      })
      .catch(function () {});
  }

  if (window.WishlistKing && window.WishlistKing._apis) {
    syncState();
  } else {
    var t = setInterval(function () {
      if (window.WishlistKing && window.WishlistKing._apis) {
        clearInterval(t);
        syncState();
      }
    }, 100);
    setTimeout(function () { clearInterval(t); }, 5000);
  }
})();


/* Sundreamer Size Chart Drawer */
(function () {
  var activeDrawer = null;
  var activeTrigger = null;
  var scrollbarPadding = 0;

  function getFocusable(container) {
    return Array.prototype.slice.call(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) {
      return el.offsetWidth || el.offsetHeight || el === document.activeElement;
    });
  }

  function openDrawer(trigger) {
    var drawerId = trigger.getAttribute('aria-controls');
    var drawer = drawerId && document.getElementById(drawerId);
    if (!drawer) return;

    if (drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }

    activeDrawer = drawer;
    activeTrigger = trigger;
    scrollbarPadding = window.innerWidth - document.documentElement.clientWidth;

    if (scrollbarPadding > 0) {
      document.body.style.paddingRight = scrollbarPadding + 'px';
    }

    trigger.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('js-drawer-open');
    document.documentElement.classList.add('holster-size-chart-is-open');

    window.requestAnimationFrame(function () {
      drawer.classList.add('drawer--is-open');

      var closeButton = drawer.querySelector('[data-size-chart-close]');
      if (closeButton) {
        closeButton.focus({ preventScroll: true });
      }
    });
  }

  function closeDrawer() {
    if (!activeDrawer) return;

    var drawer = activeDrawer;
    var trigger = activeTrigger;

    drawer.classList.remove('drawer--is-open');
    document.documentElement.classList.remove('js-drawer-open');
    document.documentElement.classList.add('js-drawer-closing');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }

    activeDrawer = null;
    activeTrigger = null;

    window.setTimeout(function () {
      drawer.setAttribute('aria-hidden', 'true');

      if (!document.querySelector('.drawer--is-open')) {
        document.documentElement.classList.remove('js-drawer-closing');
        document.documentElement.classList.remove('holster-size-chart-is-open');
        document.body.style.paddingRight = '';
      }

      if (trigger) {
        trigger.focus({ preventScroll: true });
      }
    }, 460);
  }

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest('[data-size-chart-open]');
    if (trigger) {
      evt.preventDefault();
      openDrawer(trigger);
      return;
    }

    if (!activeDrawer) return;

    if (evt.target.closest('[data-size-chart-close]')) {
      evt.preventDefault();
      closeDrawer();
      return;
    }

    if (!evt.target.closest('[data-size-chart-dialog]')) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (evt) {
    if (!activeDrawer) return;

    if (evt.key === 'Escape') {
      closeDrawer();
      return;
    }

    if (evt.key !== 'Tab') return;

    var focusable = getFocusable(activeDrawer);
    if (!focusable.length) {
      evt.preventDefault();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (evt.shiftKey && document.activeElement === first) {
      evt.preventDefault();
      last.focus();
    } else if (!evt.shiftKey && document.activeElement === last) {
      evt.preventDefault();
      first.focus();
    }
  });
})();


/* Language selector: remember explicit choice → suppress auto browser-language redirect.
   Scoped to [data-disclosure-locale] so currency picks (same markup) don't match.
   Capture phase so it writes before Impulse's disclosure.js submits the form and reloads. */
(function () {
  document.addEventListener('click', function (e) {
    var opt = e.target.closest &&
      e.target.closest('[data-disclosure-locale] [data-disclosure-option][data-value]');
    if (!opt) return;
    var iso = opt.getAttribute('data-value');
    if (!iso) return;
    try { localStorage.setItem('holster_language_redirect_v1', 'manual_' + iso); } catch (err) {}
  }, true);
})();
